import {CardApi} from './card_api'
import {PersonApi} from './dept_person_api'
import {DeviceApi} from './device_api'
import {MerchantApi} from './merchant_api'

export const ApplyBasicApi = {
  CardApi,
  PersonApi,
  DeviceApi,
  MerchantApi
}



// WEBPACK FOOTER //
// ./src/request/ApplyBasic/apply_basic_api.js